export default __webpack_public_path__ + "static/media/Logo.142a7a08.png";